<template>
    <div class="media-manager">       
        <div class="media-manager__content">
            <div class="media-manager__info">
                Drag media to reorder or hover over an item and click the 'X' to delete it from the media album.
            </div>
            
            <div class="media-manager__grid">
                <draggable
                    class="media-manager__draggable"
                    v-model="sortableMedia"
                    @end="saveSortOrders(false)">
                    <div v-for="item in sortableMedia" :key="item.id" class="media-manager__item">
                        <img class="media-manager__thumbnail" :src="item.is_image ? item.view_url : '/img/video.png'" :alt="item.name" />
                        <div 
                            v-if="item.view_url != '/img/temp/building-sample.jpg'" 
                            @click="deleteMediaConfirmation(item)" 
                            class="media-manager__delete">
                            <theme-icon icon="trash" type="icons" />
                        </div>
                    </div>
                </draggable>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import draggable from "vuedraggable";
    import ThemeIcon from './ThemeIcon.vue';

    export default {
        name: 'MediaManagerV1',
        
        components: {
            draggable,
            'theme-icon': ThemeIcon
        },

        props: {
            media: {
                type: [Array, Object],
                required: true
            },

            documentableId: {
                type: Number,
                required: true
            },

            documentableType: {
                type: String,
                required: true
            },

            showUploadButton: {
                type: Boolean,
                default: true
            },
        },

        data() {
            return {
                galleryMedida: this.media,
                loading: false
            }
        },

        watch: {
            loading(newVal) {
                this.$emit('update:loading', newVal);
            }
        },

        computed: {
            ...mapState(['documents']),

            sortableMedia: {
                get() {
                    return _.sortBy(this.galleryMedida, 'sort_order');
                },
                
                set(newValues) {
                    this.galleryMedida = newValues;
                }
            },
        },

        methods: {
            saveSortOrders(closeModal = true) {
                this.loading = true;
                
                _.each(this.galleryMedida, (item, index) => {
                    item.sort_order = index + 1;
                });

                axios.patch('/api/documents', this.galleryMedida)
                    .then((response) => {
                        if (closeModal) {
                            this.$modal.hide('media-manager');
                        }

                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: 'Sort Orders Updated'
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            deleteMediaConfirmation(media) {
                this.$swal({
                    title: 'Are you sure?',
                    text: "Are you sure you want to delete this media?",
                    type: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: 'Yes - Delete it',
                    confirmButtonClass: 'btn btn-red',
                    showCancelButton: true,
                    cancelButtonClass: 'btn btn-secondary mr-4',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.deleteDocument(media);
                    }
                });
            },

            deleteDocument(media) {
                axios.delete('/documents/' + media.id)
                    .then((response) => {
                        this.sortableMedia = _.reject(this.sortableMedia, (item) => {
                            return item.view_url == media.view_url;
                        });

                        this.$eventHub.$emit('remove-from-gallery', media.view_url);

                        if (this.sortableMedia.length == 0) {
                            this.$modal.hide('media-manager');
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: error.response.data.message
                        });
                    }
                );
            },
        },
    }
</script>
